import React from 'react';

const SvgMathMinus = (props) => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path d="M3 11v2h18v-2H3z" />
  </svg>
);

export default SvgMathMinus;
